import { FaGithub, FaDiscord } from "react-icons/fa";

export default function SocialmediaLinks() {
  return (
    <div className="flex items-center space-x-4">
        <a
            href="https://discord.gg/6XBVWSn"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Discord"
            className="text-white hover:text-purple-300 transition-transform hover:scale-110"
      >
        <FaDiscord size={24} />
      </a>
      <a
            href="https://github.com/madhouseminers"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
            className="text-white hover:text-purple-300 transition-transform hover:scale-110"
      >
        <FaGithub size={24} />
      </a>
    </div>
  );
}